import React, { useReducer, useMemo, ReactNode } from "react";
import { DelayedActionToastContext } from "./context";
import { toastReducer } from "./reducer";
import { DelayedActionToastContextType } from "./types";

interface DelayedActionToastProviderProps {
    children: ReactNode;
}

/**
 * Provider component for DelayedActionToast context
 * Manages toast state and provides dispatch function
 */
export const DelayedActionToastProvider: React.FC<DelayedActionToastProviderProps> = ({
    children,
}) => {
    const [toastState, dispatch] = useReducer(toastReducer, null);

    const contextValue = useMemo<DelayedActionToastContextType>(
        () => ({
            dispatch,
            toastState,
        }),
        [dispatch, toastState]
    );

    return (
        <DelayedActionToastContext.Provider value={contextValue}>
            {children}
        </DelayedActionToastContext.Provider>
    );
};
